import React from "react";
import { useTranslation } from "react-i18next";

import { Checkbox } from "@common/checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

const types = [
  "delayedTask",
  "addedToTask",
  "mentionInComment",
  "addedToProject",
  "projectStatusChanged",
];

function Notifications({ preferences, edit }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.notifications}>
      {types.map((type) => (
        <div key={type} className={styles.group}>
          <p className={styles.label}>
            {t(`preferences.notifications.${type}.title`)}
          </p>
          <div className={styles.formWrapper}>
            <div
              className={styles.checkbox}
              onClick={() =>
                edit({
                  ...preferences,
                  [`notifications.mail.${type}`]:
                    preferences[`notifications.mail.${type}`] === "true"
                      ? "false"
                      : "true",
                })
              }
            >
              <Checkbox
                isChecked={preferences[`notifications.mail.${type}`] === "true"}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export { Notifications };
